import Vue from "vue";

function randomString() {
  return Math.random().toString(36).substring(2)
}

const state = {
  messages: {
    'error': [],
    'warning': [],
    'status': []
  }
};

const getters = {

  getErrorMessages(state) {
    return state.messages['error']
  },

  getWarningMessages(state) {
    return state.messages['warning']
  },

  getStatusMessages(state) {
    return state.messages['status']
  },

};

const mutations = {
  addMessage(state, message) {
    if ('message' in message === false || typeof message.message !== 'string' || message.message === '') {
      return
    }

    if ('type' in message === false) {
      message.type = 'status'
    }

    if ('args' in message === false) {
      message.args = []
    }

    if ('delay' in message === false) {
      message.delay = 4000
    }

    message.key = randomString();

    state.messages[message.type].push(message);

    if (message.delay > 0) {
      setTimeout(() => this.commit('messages/removeMessage', message.key), message.delay);
    }
  },

  removeMessage(state, key) {
    let type;
    for (type in state.messages) {
      let ms = state.messages[type];
      let index;
      for (index in ms) {
        if (ms[index].key === key) {
          Vue.delete(state.messages[type], index);
          return;
        }
      }
    }
  },

  flushMessages(state) {
    Vue.set(state.messages, 'error', []);
    Vue.set(state.messages, 'warning', []);
    Vue.set(state.messages, 'status', []);
  },

};

const actions = {
  addErrorMessage(ctx, message) {
    ctx.commit('addMessage', {message: message, type: 'error'})
  },

  addWarningMessage(ctx, message) {
    ctx.commit('addMessage', {message: message, type: 'warning'})
  },

  addStatusMessage(ctx, message) {
    ctx.commit('addMessage', {message: message, type: 'status'})
  },

  // @see noker() in '@/api/index.js'
  httpErrorMessage(ctx, error) {
    if (error.code === 401) {
      ctx.commit('addMessage', {
        type: 'error',
        message: 'You are not authenticated. Please <a href="%s">log in</a>.',
        args: ['/login']
      });
      return;
    }

    if (error.message === "") {
      ctx.dispatch('addErrorMessage', error.code + ": " + error.httpMessage);
    } else {
      ctx.dispatch('addErrorMessage', error.message);
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/messages.js